export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_products(state, {products}) {
    state.products = products.data;
    state.totalCount = products.total;
    state.count = products.total;
  },
  clear_products(state) {
    state.products = []
    state.totalCount = 0;
    state.count = 0;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
